import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface IrandomCombPolitehnika {
  main_combination_id: string;
  codevar: string;
  email: string;
}

const randomCombPolitehnika = async (
  email: string,
  bottleCode: string
): Promise<IrandomCombPolitehnika | boolean> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/politehnika/random-comb-main`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/random-comb-main`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        code: bottleCode,
        email: email,
      },
    };
    const response: AxiosResponse = await axios(config);
    const { data } = response.data;

    return data;
  } catch (error) {
    return false;
  }
};

export default randomCombPolitehnika;

